import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  width?: string;
  className?: string;
}

const Star: React.FC<CustomIconProps> = ({ width, className }) => (
  <svg
    width={width ?? '40'}
    height={width ?? '40'}
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect
      width='40'
      height='40'
      rx='20'
      fill='url(#paint0_linear_12378_63820)'
    />
    <path
      d='M18.5342 13.0206C19.0377 11.6598 20.9623 11.6598 21.4658 13.0206L22.7056 16.371C22.8639 16.7988 23.2012 17.1361 23.629 17.2944L26.9794 18.5342C28.3402 19.0377 28.3402 20.9623 26.9794 21.4658L23.629 22.7056C23.2012 22.8639 22.8639 23.2012 22.7056 23.629L21.4658 26.9794C20.9623 28.3402 19.0377 28.3402 18.5342 26.9794L17.2944 23.629C17.1361 23.2012 16.7988 22.8639 16.371 22.7056L13.0206 21.4658C11.6598 20.9623 11.6598 19.0377 13.0206 18.5342L16.371 17.2944C16.7988 17.1361 17.1361 16.7988 17.2944 16.371L18.5342 13.0206Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_12378_63820'
        x1='39.8795'
        y1='20'
        x2='0.120481'
        y2='20'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#7E0D9D' />
        <stop offset='0.5' stopColor='#7328F2' />
        <stop offset='1' stopColor='#51A0F7' />
      </linearGradient>
    </defs>
  </svg>
);

export default Star;
